module.exports = __webpack_public_path__ + "img/filter.544eb8d3.svg";